import { isIframeElement } from "../element/typeChecks";
import {
  ExcalidrawIframeElement,
  NonDeletedExcalidrawElement,
} from "../element/types";
import { ElementOrToolType } from "../types";

export const hasBackground = (type: ElementOrToolType) =>{
  if (type === "stickyNotes") {
    return false;
  }
  return (
      type === "rectangle" ||
      type === "roundedRectangle" ||
      type === "ellipse" ||
      type === "triangle" ||
      type === "diamond" ||
      type === "bubble" ||
      type === "parallelogram" ||
      type === "pentagram" ||
      type === "thickArrow" ||
      type === "iframe" ||
      type === "embeddable" ||
      type === "line" ||
      type === "freedraw" ||
      type === "highlighter" ||
      type === "frame"
  );
};
export const hasTextColor = (type: ElementOrToolType) => type === "stickyNotes";

export const hasTextSize = (type: ElementOrToolType) => type === "stickyNotes";
export const hasTextFont = (type: ElementOrToolType) => type === "stickyNotes";

export const hasStrokeColor = (type: ElementOrToolType) =>true
    /*(type !== "image") && type !== "frame" && type !== "magicframe"*/;

export const hasCorner = (type:ElementOrToolType) =>
  (type === 'rectangle' || type === 'roundedRectangle' || type === "bubble")


export const hasStrokeWidth = (type: ElementOrToolType) =>
    type === "rectangle" ||
    type === "roundedRectangle" ||
    type === "ellipse" ||
    type === "triangle" ||
    type === "diamond" ||
    type === "bubble" ||
    type === "parallelogram" ||
    type === "pentagram" ||
    type === "thickArrow" ||
    type === "iframe" ||
    type === "embeddable" ||
    type === "freedraw" ||
    type === "arrow" ||
    type === "line";

export const hasStrokeStyle = (type: ElementOrToolType) =>
    type === "rectangle" ||
    type === "roundedRectangle" ||
    type === "ellipse" ||
    type === "triangle" ||
    type === "diamond" ||
    type === "bubble" ||
    type === "parallelogram" ||
    type === "pentagram" ||
    type === "thickArrow" ||
    type === "iframe" ||
    type === "embeddable" ||
    type === "arrow" ||
    type === "line";

// 没有圆形，单独区分
// 边能否变平滑
export const canChangeRoundness = (type: ElementOrToolType) =>
    // type === "rectangle" ||
    // type === "roundedRectangle" ||
    // type === "ellipse" ||
    type === "triangle" ||
    type === "diamond" ||
    // type === "bubble" ||
    // type === "parallelogram" ||
    // type === "pentagram" ||
    // type === "thickArrow" ||
    type === "iframe" ||
    type === "embeddable" ;
    // type === "arrow" ||
    // type === "line";

export const canHaveArrowheads = (type: ElementOrToolType) => type === "arrow";

export const canChangeLineType = (type: ElementOrToolType) =>
    type === "arrow" || type === "line";

export const getElementAtPosition = (
    elements: readonly NonDeletedExcalidrawElement[],
    isAtPositionFn: (element: NonDeletedExcalidrawElement) => boolean,
) => {
  let hitElement = null;
  // We need to to hit testing from front (end of the array) to back (beginning of the array)
  // because array is ordered from lower z-index to highest and we want element z-index
  // with higher z-index
  for (let index = elements.length - 1; index >= 0; --index) {
    const element = elements[index];
    if (element.isDeleted) {
      continue;
    }
    if (isAtPositionFn(element)) {
      hitElement = element;
      break;
    }
  }

  return hitElement;
};

export const getElementsAtPosition = (
    elements: readonly NonDeletedExcalidrawElement[],
    isAtPositionFn: (element: NonDeletedExcalidrawElement) => boolean,
) => {
  const iframeLikes: ExcalidrawIframeElement[] = [];
  // The parameter elements comes ordered from lower z-index to higher.
  // We want to preserve that order on the returned array.
  // Exception being embeddables which should be on top of everything else in
  // terms of hit testing.
  const elsAtPos = elements.filter((element) => {
    const hit = !element.isDeleted && isAtPositionFn(element);
    if (hit) {
      if (isIframeElement(element)) {
        iframeLikes.push(element);
        return false;
      }
      return true;
    }
    return false;
  });
  return elsAtPos.concat(iframeLikes);
};
